import BusinessFooter from '@components/BusinessFooter';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useTermCategories from '@hooks/term/useTermCategories';
import useProject from '@hooks/useProject';
import { Link } from '@router/Link';
import { Fragment } from 'react';

function MainFooter() {
  const terms = useTermCategories('MAIN');
  const project = useProject();
  if (project?.businessProfile) {
    const arr:string[] = [];
    const {
      brandName, bizName, nameEn, representativeName,
      businessRegistrationNumber, salesReportNumber, addrRoad, addrDetail, email, contact,
    } = project.businessProfile;
    if (brandName) {
      arr.push(brandName);
    }
    arr.push(bizName);
    if (nameEn) {
      arr.push(nameEn);
    }
    arr.push(`대표자: ${representativeName}`);
    arr.push(`사업자 등록 번호: ${businessRegistrationNumber}`);
    arr.push(`통신판매업 신고번호: ${salesReportNumber}`);
    arr.push(`사업장 주소: ${addrRoad} ${addrDetail ? `, ${addrDetail}` : ''}`);
    arr.push(`이메일 주소: ${email}`);
    if (contact) {
      arr.push(`전화번호: ${contact}`);
    }
    const content = arr.join('\n');
    return (
          <BusinessFooter>
              {content}
              <br/>
              <Row spacing={8}>
                  {terms?.map((termCategory, index) => (
                      <Fragment key={termCategory.id}>
                          <Link activityName='TermDetailActivity'
                                activityParams={{ termCategoryId: termCategory.id }}>
                              <Text size='s' fontWeight='medium' color={colors.gray7}>
                                  {termCategory.title}
                              </Text>
                          </Link>
                          {index + 1 !== terms.length && (
                              <Text size='s'>|</Text>
                          )}
                      </Fragment>
                  ))}
              </Row>
          </BusinessFooter>
    );
  }
  return (<Fragment/>);
}

export default MainFooter;
